import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
const AppIconsEmergency= React.forwardRef((props: SvgIconProps, ref: any) => {
  return (
    <SvgIcon {...props} ref={ref}>
      

      <g fill="currentColor">
	<path d="M17.8067894,7.0203204V2.9426346H6.1977501H6.1977487v4.0776858H0.6382979v14.0370445H23.361702V7.0203204H17.8067894z
		 M7.1144896,3.8593771H7.114491h9.7732868v3.1609447H7.1144896V3.8593771z M22.4449596,20.1383533H1.5573092V7.939333h20.8876495
		V20.1383533z"/>
	<polygon points="11.9977303,8.9854164 11.9997911,8.985446 12.0022688,8.9854164 	"/>
	<path d="M11.9977303,19.0877323c2.7888021,0,5.051157-2.2578163,5.0534267-5.0466194v-0.0022688
		c-0.0045376-2.7881126-2.2635126-5.0477476-5.0513659-5.0533981c-2.7876625-0.0009251-5.0509501,2.2608871-5.0509501,5.0488596
		C6.9488411,16.8231068,9.2089291,19.0877323,11.9977303,19.0877323z M11.9977312,9.9066982
		c2.2827778,0,4.1321459,1.8493681,4.1321459,4.1321459c-0.0045376,2.280509-1.8516359,4.1276083-4.1321459,4.1321459
		c-2.2827787,0-4.1321473-1.8493671-4.1321473-4.1321459S9.7149525,9.9066982,11.9977312,9.9066982z"/>
	<polygon points="11.5416288,16.5167694 12.46064,16.5167694 12.46064,14.4972143 14.4779272,14.4972143 14.4779272,13.580472 
		12.46064,13.580472 12.46064,11.5631857 11.5416288,11.5631857 11.5416288,13.5827417 9.5243435,13.5827417 9.5243435,14.5017529 
		11.5416288,14.5017529 	"/>
</g>
    </SvgIcon>
  );
});

export default AppIconsEmergency;
